import type { ChatRequestPageContext } from '~/api/shopping-assistant/types'

import { useShoppingAssistantStructuredDataRegistry } from './useShoppingAssistantStructuredData'

const PRODUCT_TYPE = 'Product'

interface StructuredDataProduct {
  productID?: string
}

/**
 * Derives the seed-time page context (product_id) from the structured-data
 * registry, which the PDP populates via `useRegisterShoppingAssistantStructuredData`.
 *
 * The PDP's Product JSON-LD includes a `productID` field (added in AI-1784),
 * so this composable simply reads it back. Non-PDP pages either don't
 * register a `Product` entry (help-center, articles) or register one without
 * `productID` (product-list), so `getPageContext()` returns `null` in those
 * cases — no false positives.
 */
export function useShoppingAssistantPageContext() {
  const { registry } = useShoppingAssistantStructuredDataRegistry()

  function getPageContext(): ChatRequestPageContext | null {
    const product = registry.value[PRODUCT_TYPE] as
      | StructuredDataProduct
      | undefined

    if (product?.productID) {
      return {
        type: 'product_page',
        product_id: product.productID,
      }
    }

    return null
  }

  return {
    getPageContext,
  }
}
